module.exports = __webpack_public_path__ + "img/cpu-4393376_1920.e32efc61.jpg";